import api from './api';

const videoService = {
  generateFromTopic: (data) => api.post('/videos/generate-topic', data),
  generateFromTopicJob: (data, config = {}) => api.post('/videos/generate-topic-job', data, config),

  generateFromUpload: (formData) =>
    api.post('/videos/generate-upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  generateFromUploadJob: (formData, config = {}) =>
    api.post('/videos/generate-upload-job', formData, {
      ...config,
      headers: { 'Content-Type': 'multipart/form-data', ...(config.headers || {}) },
    }),
  getGenerationJob: (jobId, config = {}) => api.get(`/videos/generate-job/${jobId}`, config),

  getVideos: (filters = {}) => api.get('/videos', { params: filters }),

  getById: (id) => api.get(`/videos/${id}`),

  updateSlides: (id, slides) => api.put(`/videos/${id}/slides`, { slides }),

  updateQuiz: (id, questions) => api.put(`/videos/${id}/quiz`, { questions }),

  generateAllAudio: (id, voice) => api.post(`/videos/${id}/audio`, { voice }),

  regenerateSlideAudio: (id, slideId, voice) =>
    api.post(`/videos/${id}/slides/${slideId}/audio`, { voice }),

  updateSlideDiagram: (id, slideId, diagramSvg, excalidrawElements = null, excalidrawFiles = null) =>
    api.put(`/videos/${id}/slides/${slideId}/diagram`, {
      diagram_svg: diagramSvg,
      excalidraw_elements: excalidrawElements,
      excalidraw_files: excalidrawFiles,
    }),

  deleteVideo: (id) => api.delete(`/videos/${id}`),

  archiveVideo: (id) => api.post(`/videos/${id}/archive`),

  // PPTX export — axios blob so auth header is included automatically
  exportPptx: (id) => api.get(`/videos/${id}/export/pptx`, { responseType: 'blob' }),

  // MP4 Export
  createExportJob: (id) => api.post(`/videos/${id}/export`),
  getExportJob: (jobId) => api.get(`/videos/export/${jobId}`),
  deleteExportJob: (jobId) => api.delete(`/videos/export/${jobId}`),
  getExportDownloadUrl: (jobId) => `/videos/export/${jobId}/download`,
};

export default videoService;
